export default "__VITE_ASSET__BIqNWS_o__"